var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-modal",
        {
          attrs: {
            title: "Google验证码验证",
            confirmLoading: _vm.loading,
            maskClosable: false,
            width: "400px",
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            { staticClass: "google-verify-content" },
            [
              _c(
                "div",
                { staticClass: "verify-tips" },
                [
                  _c("a-icon", {
                    staticStyle: { color: "#1890ff", "margin-right": "8px" },
                    attrs: { type: "safety-certificate" },
                  }),
                  _c("span", [_vm._v("请输入您的6位Google验证码")]),
                ],
                1
              ),
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.formData,
                    rules: _vm.rules,
                    "label-col": { span: 0 },
                    "wrapper-col": { span: 24 },
                  },
                },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { prop: "code" } },
                    [
                      _c("a-input", {
                        ref: "codeInput",
                        staticClass: "google-code-input",
                        attrs: {
                          placeholder: "请输入6位Google验证码",
                          maxLength: 6,
                        },
                        on: { pressEnter: _vm.handleOk },
                        model: {
                          value: _vm.formData.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "code", $$v)
                          },
                          expression: "formData.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "verify-notes" }, [
                _c("p", [_vm._v("• 验证码为6位数字")]),
                _c("p", [_vm._v("• 验证码每30秒更新一次")]),
                _c("p", [_vm._v("• 请确保手机时间准确")]),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }